const sc = {
  header: {
    home: "餐饮",
    about: "关于我们",
    love: "婚宴及推广",
    link: "投资者关系",
    contact: "联系我们",
    hover: {
      home: "主页",
      coffee: "猫屎咖啡",
      restaurant: "餐饮服务",
      about: "关于我们",
      investor: "投资者关系",
      contact: "联系我们",
      join: "加入我们"
    }
  },
  footer: {
    title1: "免责声明",
    title2: "使用条款",
    title3: "隐私政策及声明",
    company: "猫屎咖啡控股有限公司"
  },
  home: {
    map_title: "关于利宝阁",
    map_content: "利宝阁经营中式餐饮服务，业务遍布香港及内地。凭借对粤菜的热诚及食客为先的理念，集团以旗舰品牌「利宝阁」于中港两地开设酒家",
    find_title: "发现 我们的故事",
    find_content: "利宝阁是一家餐饮企业，提供粤菜佳肴﹑中式筵席及餐饮服务。",
    find_btn: "联系我们",
    company_title: "餐饮品牌",
    company_more: "按此了解更多"
  },
  about: {
    title: "关于我们",
    title1: "粤菜翘楚",
    content1: "「利宝阁」是香港知名的餐饮品牌之一，以传统粤菜闻名。集团第一家酒楼于1998年在香港铜锣湾隆重开业，多年来凭着对粤菜的热诚及卓越的经营，集团的业务版图已延伸至中国内地，成为一间营运模式多元化及规模庞大的香港上市餐饮企业。",
    title2: "推陈出新 奋勇开创新篇章",
    content2: "集团呈献的正宗粤菜经过精烹细琢，结合上乘的食材及精湛的厨艺，广受食客推崇。长久以来，集团在菜式上致力推陈出新，细腻演绎粤菜经典的同时，为食物注入各种创新元素，在满足食客味蕾的同时，亦为食客带来具新鲜感的餐饮体验。集团推出的创新陈皮烤鸭及栩栩如生的造型点心已成为品牌的标志菜式，也是食客到访利宝阁必尝的美食。深耕香港市场多年后，「利宝阁」品牌声誉满载；2013年集团正式进军内地市场，在深圳福田开设集团内地的首家酒楼。凭着力臻完善的经营态度，加上优质的食品，利宝阁品牌在内地深受食客欢迎；短短几年间，集团已在深圳开设三间分店，其食物品质大受好评。 2016年，集团于香港联交所创业板上市；2018年，集团转至主板上市，充分反映资本市场对集团的认同。",
    title3: "与时俱进 积极开拓新零售模式",
    content3: "作为一间与时俱进的企业，利宝阁为广大消费者带来全新的消费模式，抓紧互联网餐饮带来的蓬勃机遇。 2019年集团与阿里巴巴集团旗下的电商品牌盒马鲜生建立策略合作关系；背靠盒马的强大网络以实体店+网上订购平台的新零售模式，提供餐饮外卖及送餐市场。根据协议，利宝阁于盒马鲜生内开设店中店，销售现场烹制的港式烧味餐膳食品，以及提供汤水、点心、甜品及节日食品等具特色的菜式，务求令客人安坐家中，就可品尝到新鲜佳肴。",
    content4: "2020年，集团在中国的业务更上一层楼。集团成功收购国内烧腊行业领军者之一的上海新玖记70%股份，以配合集团以轻资产的商业模式开拓中国「新零售」轻膳送餐市场的布局。上海新玖记有丰富的新零售经验，其烤鸭食品扬名中外。",
    content5: "默默耕耘廿多年，集团已由一家传统酒楼发展成为一间多元餐饮服务的领先企业，业务涵盖中式筵席、O2O轻膳送餐服务等；业务版图覆盖香港、深圳及上海等市场。 「利宝阁」品牌不仅仅承传粤菜的经典，也展演出一份创新求变、追求卓越的企业家精神。",
    history: {
      title: "发展历程"
    },
  },
  wedding: {
    title: "婚宴场地",
    new_title: "最新推广及活动"
  },
  disclaimer: {
    title: "免责声明",
    t: "本网站所载资料只供参考，如有更改，恕不另行通知。本公司并不保证该等资料之准确性及完整性。对于使用或依赖本网站资料，或因经本网站连结所取得之其他互联网资料，所引致的任何损失，本公司概不负责。\n" +
      "‍\n" +
      "互联网使用者可自行复制、发布或传递有关资料作个人使用，唯不能作任何商业用途；使用时必须完整复制，并须标明资料来源。本公司不会就资料之使用负上任何责任。"
  },
  use: {
    title: "使用条款",
    t: "欢迎浏览猫屎咖啡控股有限公司(下称「猫屎咖啡」或「我们」或「我们的」)的网站。凡于使用条款及细则内提述「阁下」及「阁下的」包括进入本网站的任何人士。\n" +
      "‍\n" +
      "在使用本网站及其内容(下称「本网站」)前，请仔细阅读以下有关使用本网站的条款及细则(下称「使用条款」)。鉴于阁下使用本网站时，即表明阁下同意使用条款。我们有权于任何时间修订或更改使用条款。任何修订或更改将于本网站上发布。若阁下继续使用本网站，即表明接受该等修订或更改之约束。\n" +
      "‍\n" +
      "阁下同意不会(a)干扰或试图干扰我们的软件之正常运作或任何透过本网站而传送的任何服务；(b)在未经授权情况下，进入或试图进入我们的电脑系统或其他使用者的电脑系统；(c)收集或试图收集其他使用者的资料；或(d)作出任何导致或可能导致我们提供予使用者之服务受到中断或质量降低的行为或本网站被改变或涂污的行为。\n" +
      "‍\n" +
      "1. 拥有权\n" +
      "1.1 关于本网站及其设计之所有知识产权及商誉是属于我们或第三者或由我们或第三者已合法地获取特许/牌照用于本网站。阁下不得复制、复印、修改、更改、变更、修订、传送、载录、散布、分发、宣报、刊载或显示本网站或储存于检索系统或使用本网站制作任何衍生作品或销售本网站提供之产品或服务或侵犯我们或第三者的知识产权，惟阁下可将本网站任何部份下载一份至任何一部电脑作阁下之私人及非商业性用途，但阁下必须将所有版权及其他所有权声明完整地保留。使用条款在任何情况下，不会被诠释为向阁下授予任何属于我们或第三者之知识产权或商誉的权利、所有权或权益。我们或第三者特此保留一切适用法律之权利。\n" +
      "‍\n" +
      "1.2 阁下同意在未得我们事先书面同意之前，不可将本网站显示在框格(frame)或与本网站连结(link)或将阁下与本网站相联。\n" +
      "‍\n" +
      "2. 内容\n" +
      "猫屎咖啡经已作出一切合理安排以确保本网站所提供之资讯及资料均为正确及最新的。但是，我们否认所有明示或隐含的保证，并不会就该等资讯及资料之准确性、适时性、充足性、可靠性或完整性作出任何表述。\n" +
      "‍\n" +
      "3. 本网站之使用\n" +
      "3.1 阁下不得滥用本网站，借本网站引进病毒、蠕虫病毒(worms)、逻辑炸弹病毒、恶意的或技术上有害的或含有污染或破坏元素的其他材料。阁下在未经许可情况下，不得存取或试图存取本网站、储存本网站之伺服器或电脑、或与本网站相连之任何伺服器、电脑或资料库。\n" +
      "‍\n" +
      "3.2 阁下不得利用本网站传送虚假、非法、骚扰性、诽谤性、辱骂性、憎恨性、歧视的、威吓的、有害的、粗俗的、猥亵的、煽动性或其他引起反对或冒犯性之任何种类或性质的材料。\n" +
      "‍\n" +
      "3.3 阁下同意只可使用本网站作非商业性、个人及合法之用途。\n" +
      "‍\n" +
      "3.4 因阁下使用本网站而导致任何病毒、蠕虫病毒(worms)、逻辑炸弹病毒、含有污染或破坏元素的材料或其他恶意或技术上有害的材料有可能影响阁下的设备、资料库或其他材料所产生的任何损失或损害，我们概不负责。\n" +
      "‍\n" +
      "3.5 我们保留权利可在不作通知的情况下，于任何时间终止阁下进入本网站或拒绝让阁下使用本网站或其服务。\n" +
      "‍\n" +
      "4. 个人资料收集声明\n" +
      "当阁下使用本网站，阁下可能向我们提供你的个人资料。阁下同意所提供的该等个人资料乃属自愿性质。我们有权因应收集目的及适用法律继续保留该等个人资料。我们会根据我们的私隐政策使用阁下的个人资料，阁下亦同意接受我们的私隐政策，有关政策可从私隐政策连结参阅。阁下确认阁下所提供的资料是属实、正确、有效和完整的。\n" +
      "‍\n" +
      "5. 保证及法律责任\n" +
      "5.1 阁下同意是在风险自负之情况下使用本网站。就使用本网站、依靠本网站提供有关猫屎咖啡、我们之相关联公司、附属公司、母公司、联系公司、供应商及/或业务伙伴之任何资讯或资料、本网站遗漏任何有关猫屎咖啡、我们之相关联公司、附属公司、母公司、联系公司、供应商及/或业务伙伴之资讯或资料、任何上载至本网站的材料或与本网站之连结，我们概不负责。\n" +
      "‍\n" +
      "5.2 我们没有代表任何第三者之授权。阁下同意我们不会就阁下与第三者之任何索偿、纠纷、偿付或合约承担任何责任。\n" +
      "‍\n" +
      "5.3 本网站之资料是按\"现状\"提供的，当中并没有包含任何明确或隐含保证。我们可在不作事先通知的情况下，于任何时间对其作出更改。\n" +
      "‍\n" +
      "5.4 我们不就下述情形作出任何明示或隐含的声明或保证:\n" +
      "(a)本网站可于任何时间在持续及不被中断之基础上可供存取或本网站之运作、品质及供存取性能；\n" +
      "(b)本网站或任何透过本网站取得的材料是没有病毒、蠕虫病毒(worms)、逻辑炸弹病毒、恶意或技术上有害的材料或含有污染或破坏元素的材料包括但不限于该等病毒或其他程式会令阁下之资料或财产受损；\n" +
      "(c)使用本网站将取得任何特定结果；及\n" +
      "(d)纠正本网站的任何不足之处。\n" +
      "‍\n" +
      "5.5 若阁下因使用本网站而须更换任何设备或软件或资料库受损，我们概不负责。\n" +
      "‍\n" +
      "5.6 因使用或不能使用本网站或使用或依靠本网站之任何资讯而导致的任何损失(不论直接、间接、特殊或必然的)、损害或伤害(不论是否合约、侵权(包括疏忽)、违反法定责任或其他行为)，即使是可预见的，阁下同意豁免我们的法律责任或将其减至法律范围内最低。为免生疑，使用条款并不免除或局限我们因我们、我们的雇员或代理人之疏忽或欺诈或失实陈述所引致死亡或人身伤害的责任。\n" +
      "‍\n" +
      "5.7 于互联网上传递之讯息并不保证绝对安全；同时，阁下因透过互联网向猫屎咖啡、我们之相关联公司、附属公司、母公司、联系公司、供应商及/或业务伙伴传送讯息或要求猫屎咖啡、我们之相关联公司、附属公司、母公司、联系公司、供应商及/或业务伙伴透过互联网向阁下发出之讯息如有任何延误、损失、误传、变更或损毁，我们对此而引致之损失或损害，概不负责。\n" +
      "‍\n" +
      "6. 弥偿\n" +
      "因阁下违反使用条款、或不遵守使用条款或透过本网站而取得的任何材料所引致的任何责任，阁下同意完全弥偿我们、我们之附属公司、母公司、雇员及代理人因此所引致的全部申索、损失、损害、费用及支出(包括法律费用)，并就任何申索、损失、损害、费用及支出(包括法律费用)为我们、我们之附属公司、母公司、雇员及代理人进行抗辩。\n" +
      "‍\n" +
      "7. 可分割性\n" +
      "使用条款的任何条文在某司法管辖区的法律若属不合法、无效或无法执行，将不影响该有关条文在其他司法管辖区的合法性、有效性及可执行性，同时，也不会影响其他条文的合法性、有效性及可执行性。\n" +
      "‍\n" +
      "8. 一般事项\n" +
      "8.1 本使用条款的中英文本如有任何矛盾或不一致，应以中文本为准，英文仅供参考。\n" +
      "‍\n" +
      "8.2 本使用条款根据香港特别行政区(\"香港\")法律诠释，并受香港法律管辖。就使用条款或阁下使用本网站所引致的任何纠纷，阁下同意香港法庭享有专有司法管辖权。\n" +
      "‍\n" +
      "9. 杂项\n" +
      "任何违反事项之宽免并不构成对其他违反事项之宽免。使用条款内之标题仅为方便参考而设，不影响使用条款的诠释。"
  },
  desc: {
    title: "私隐政策及声明",
    t: "本声明旨在说明猫屎咖啡控股有限公司(「猫屎咖啡」或下称「我们」或「我们的」)透过位于http://kafelaku.com的网页(下称「本网站」)就有关收集阁下的个人资料(下称「资料」)及其使用的处理方法。凡于本声明内「阁下」或「阁下的」包括进入本网站及提交资料的任何人士。\n" +
      "‍\n" +
      "请仔细阅读本声明。鉴于阁下使用本网站或向我们递交阁下的资料，即表明阁下同意接受本声明。我们有权于任何时间修订或更改本声明。任何修订或更改将于本网站上发布。在本声明修订或更改后，若阁下继续使用本网站，即表明接受该等修订或更改之约束。无论如何，若有任何修订或更改关于我们如何收集及使用阁下的资料，我们会在作出该修订或更改前向阁下取得同意。\n" +
      "‍\n" +
      "1. 个人资料(私隐)条例\n" +
      "就阁下的资料之收集、运用、贮存、保留、披露、转移、提供、供存取、保护及存取，我们遵守个人资料(私隐)条例(香港特别行政区法例第486章)所述的规定。\n" +
      "‍\n" +
      "2. 收集资料及资讯\n" +
      "2.1 当阁下使用本网站，我们可能向阁下收集资料，包括但不限于阁下的姓名、地址、联络资料(包括电话、流动电话及传真号码)、信用咭资料(若阁下订购我们的产品或服务) 、电邮地址、网际网路通讯协议(IP)地址、操作系统的类型、浏览器类别、域名、登入时间及与阁下要求获取资料或服务有关的其他人士的其他资料，并会作下列用途:\n" +
      "(a) 就招聘、产品及服务提供及/或顾客服务之用途作身份核实及纪录；\n" +
      "(b) 以达成阁下对我们的产品或服务订购要求，并处理订单、付款及任何帐项偿付；\n" +
      "(c) 于我们的内部数据库保存通讯联络资料；\n" +
      "(d) 汇制本网站使用量的统计；\n" +
      "(e) 回应及处理阁下的任何查询或执行阁下的要求；\n" +
      "(f) 对我们的产品及服务作出评估及提升；及\n" +
      "(g) 进行与我们客户、产品、服务、活动、推广或项目有关的调查。\n" +
      "‍\n" +
      "2.2 阁下确认并同意阁下提供的资料属自愿性质。\n" +
      "‍\n" +
      "2.3 阁下可以发送电邮至enquiry@kafelaku.com，随时更改阁下就收取我们的资讯及资料所作的选择或阁下的资料。\n" +
      "‍\n" +
      "3. 使用资料作直接促销\n" +
      "3.1 我们亦会使用阁下的资料向阁下发送直接促销讯息，例如当中包含关于食品、饮料、餐饮产品及服务的消息、报价和推广之邮件、电子邮件、电话或短信。\n" +
      "‍\n" +
      "3.2 我们不会在未得阁下之书面同意前向任何第三方提供阁下的资料作直接促销用途。\n" +
      "‍\n" +
      "3.3 如阁下不欲收取任何直接促销讯息，请随时将你的要求连同你的姓名发送电邮至enquiry@kafelaku.com。\n" +
      "‍\n" +
      "4. 保安\n" +
      "我们会使用适当的安全技术及程序以保护阁下的资料，避免在未经授权情况下被存取、使用或披露。惟鉴于互联网之性质及技术，其他人仍有可能截取阁下发送至或传经本网站的资讯。我们不保证本网站不受黑客入侵或攻击。\n" +
      "‍\n" +
      "5. 披露、保留及贮存资料\n" +
      "5.1 阁下确认、同意并授权我们把资料保留及贮存在我们的一个或多个在香港境内或外的数据库内。\n" +
      "‍\n" +
      "5.2 除非阁下事先同意或法律允许，我们不会向任何第三方转移、披露、提供或供存取阁下的资料，惟下文所述情况除外：\n" +
      "(a)我们之附属公司为专业机构膳食有限公司；\n" +
      "(b)我们的雇员；\n" +
      "(c)信贷公司​​以进行付款交易；\n" +
      "(d)按适用法律、法庭命令、行政政策或规例、指引、指令或于香港或香港以外的任何监管、政府、税务、执法或其他机构，或自律规管团体或业界团体所颁布或发布的命令，或与法律程序有关，或为在香港确立、行使或抗辩的法律权利，要求我们必须向其披露之任何人士或机构；\n" +
      "(e)就我们的业务、合并、收购或转让而作出尽职审查为目的，而须予以披露之任何人士、机构或个体；\n" +
      "(f)因危及生命或紧急情况下并有助于识别个人为由，我们须向有关人士、机构、个体或机关作出披露。\n" +
      "阁下确认、同意并授权我们在执行，实施或遵守我们之使用条款及细则的任何条款或本声明的情况下转移、披露、提供或供存取阁下的资料。\n" +
      "‍\n" +
      "6. 查阅及更正资料\n" +
      "阁下有权查阅我们是否持有有关你的资料并存取任何该等资料，如有需要，阁下亦有权要求更正或更新该等资料。倘若阁下希望存取、更正或更新阁下的资料，请发送电邮至enquiry@kafelaku.com。在符合《个人资料(私隐)条例》之下我们会致力于40天内对阁下的要求作出回应。\n" +
      "‍\n" +
      "7. 曲奇档案(Cookies)\n" +
      "我们可能在本网站上使用曲奇档案。曲奇档案是由网站自动储存于个人电脑网络浏览器的小量资料，这些资料可以由该网站检索。曲奇档案所收集的信息是匿名的聚集研究数据，并没有包含名称或地址信息或使任何人可以通过电话，电子邮件或任何其他方式与阁下联系之任何信息。大多数浏览器最初设定都接受曲奇档案。倘若阁下希望停止曲奇档案的运作，阁下可以更改阁下的浏览器设定。无论如何，由于本网站的某些功能需要曲奇档案方能运作，例如：在过程中保持连续性，如果它们被停止，这些功能可能无法正常运作，这样或会使我们的部份网页不能正确或完全不能显示。\n" +
      "‍\n" +
      "8. 未成年人士\n" +
      "我们没有责任查证阁下的年龄，并假定阁下已年满十八岁或以上。若阁下年龄未满十八岁，或无能力缔结合约，在未得到你的父母/监护人事前同意情况下，阁下不应在本网站提供任何阁下的资料。我们建议儿童/未成年人士须在父母/监护人监督下上网。\n" +
      "‍\n" +
      "9. 一般事项\n" +
      "本声明的中英文本如有任何矛盾或不一致，应以中文本为准，英文仅供参考。\n" +
      "‍\n" +
      "10. 其他问题\n" +
      "倘若阁下有任何与本声明有关的查询，请发送电邮至enquiry@kafelaku.com。"
  }
}

export default sc



// WEBPACK FOOTER //
// ./src/i18n/locale/sc.js